
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import RecoverPasswordForm from "@/form/recover/recoverPassword/recoverPassword";
@Component({
  components: {FormGroup}
})
export default class RecoverPassword extends Vue {
  @Prop() readonly form!: RecoverPasswordForm;
}
